export default __webpack_public_path__ + "static/media/redux.c9be37e0.png";